import { format } from "date-fns";

export default function FilterModal({
  show,
  onClose,
  filterType,
  setFilterType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onApply,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-[2.5rem] w-full max-w-md p-8 shadow-2xl animate-in fade-in zoom-in duration-200">
        
        {/* TABS */}
        <div className="bg-slate-100 p-1.5 rounded-2xl flex mb-8">
          {["SINGLE", "RANGE", "FULL"].map((t) => (
            <button
              key={t}
              onClick={() => setFilterType(t)}
              className={`flex-1 py-2.5 rounded-xl text-[10px] font-black transition-all ${
                filterType === t
                  ? "bg-white text-[#0054A6] shadow-sm"
                  : "text-slate-400"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* CONDITIONAL INPUTS */}
        <div className="space-y-6 min-h-[160px]">
          {filterType === "SINGLE" && (
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-2">
                Select Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full bg-slate-50 border-none rounded-2xl p-4 font-bold text-slate-900 focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {filterType === "RANGE" && (
            <div className="grid grid-cols-1 gap-4">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-2">
                  Start Date
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full bg-slate-50 border-none rounded-2xl p-4 font-bold text-slate-900"
                />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-2">
                  End Date
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full bg-slate-50 border-none rounded-2xl p-4 font-bold text-slate-900"
                />
              </div>
            </div>
          )}

          {filterType === "FULL" && (
            <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100">
              <p className="text-blue-700 text-xs font-bold text-center leading-relaxed">
                This will aggregate all historical logs for this site into one document.
              </p>
            </div>
          )}
        </div>

        {/* ACTIONS */}
        <div className="flex items-center justify-between mt-10">
          <button
            onClick={onClose}
            className="text-slate-500 text-xs font-black uppercase tracking-widest px-6"
          >
            Cancel
          </button>
          <button
            onClick={onApply}
            className="bg-[#0054A6] text-white px-8 py-4 rounded-2xl text-xs font-black uppercase tracking-widest shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
}